import { User } from './types/user';
import TeleTherapyLanding from './components/tele-therapy-landing';
import TherapistList from './components/therapist-list';
import { Layout } from './components/layout';
import { AppointmentsList } from './components/appointments-list';
import { ProfilePage } from './components/profile-page';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

export const App = () => {
  const [user, setUser] = useState<User | null>(null);
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
      } catch (error) {
        console.error('Error parsing user data:', error);
        handleLogout();
      }
    }
  }, []);

  const handlePlanSession = () => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      setIsWaitlistModalOpen(true);
      return;
    }
    try {
      const userData = JSON.parse(storedUser) as User;
      setUser(userData);
    } catch (error) {
      console.error('Error parsing user data:', error);
      handleLogout();
      setIsWaitlistModalOpen(true);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const justLoggedIn = sessionStorage.getItem('justLoggedIn');
  if (justLoggedIn) {
    sessionStorage.removeItem('justLoggedIn');
    return <Navigate to="/therapists" replace />;
  }

  return (
    <Router>
      {user ? (
        <Layout onLogout={handleLogout} user={user}>
          <Routes>
            <Route path="/" element={<TherapistList />} />
            <Route path="/home" element={<TherapistList />} />
            <Route path="/appointments" element={<AppointmentsList />} />
            <Route path="/profile" element={<ProfilePage user={user} />} />
            <Route path="/therapists" element={<TherapistList />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Layout>
      ) : (
        <TeleTherapyLanding
          onPlanSession={handlePlanSession}
          onLogout={handleLogout}
          setIsWaitlistModalOpen={setIsWaitlistModalOpen}
          isWaitlistModalOpen={isWaitlistModalOpen}
        />
      )}
    </Router>
  );
};

export default App;